export default __webpack_public_path__ + "static/media/dxtrade_nameless.ece6f4e3.webp";